// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-single-select-criterion {
  position: relative;
  display: flex;
  flex: 1 0 0;
  min-width: 0;
}

.fund-single-select-button {
  box-sizing: border-box;
  display: flex;
  flex: 1 0 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 40px;
  padding: 6px 16px;
  background-color: var(--row-light);
  border: 1px solid var(--border-input);
  border-radius: 4px;
  cursor: pointer;
  color: var(--input-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    border: 1px solid var(--border-primary-brand);
  }
}

.fund-single-select-button-label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.fund-single-select-expand {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.fund-single-select-expand.open {
  transform: rotate(180deg);
}

.fund-single-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;
  background-color: var(--row-light);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  box-shadow: 0 0 12px 0 rgba(18, 18, 18, 0.05);
  padding: 8px 1px;
}

/* Classification's list runs 100+ items and needs to scroll; Asset type's
   short list should just hug its content. */
.fund-single-select-dropdown.scrollable {
  max-height: 448px;
  overflow-y: auto;
}

.fund-single-select-options {
  display: flex;
  flex-direction: column;
}

.fund-single-select-option-item {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  height: 48px;
  padding: 12px 16px;
  cursor: pointer;
  color: var(--text-primary);
  text-align: left;
}

.fund-single-select-option-item:hover {
  background-color: var(--color-brand-hover2);
}

.fund-single-select-option-item.active {
  background-color: var(--color-brand-hover2);
}
`, "",{"version":3,"sources":["webpack://./src/Components/FundScreener/Criteria/SingleSelectCriterion/SingleSelectCriterion.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,uCAAuC;EACvC,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;4CAC4C;AAC5C;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C","sourcesContent":[".fund-single-select-criterion {\n  position: relative;\n  display: flex;\n  flex: 1 0 0;\n  min-width: 0;\n}\n\n.fund-single-select-button {\n  box-sizing: border-box;\n  display: flex;\n  flex: 1 0 0;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  height: 40px;\n  padding: 6px 16px;\n  background-color: var(--row-light);\n  border: 1px solid var(--border-input);\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--input-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  &:hover {\n    border: 1px solid var(--border-primary-brand);\n  }\n}\n\n.fund-single-select-button-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fund-single-select-expand {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  transition: transform 0.15s ease;\n}\n\n.fund-single-select-expand.open {\n  transform: rotate(180deg);\n}\n\n.fund-single-select-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: var(--row-light);\n  border: 1px solid var(--border-primary);\n  border-radius: 4px;\n  box-shadow: 0 0 12px 0 rgba(18, 18, 18, 0.05);\n  padding: 8px 1px;\n}\n\n/* Classification's list runs 100+ items and needs to scroll; Asset type's\n   short list should just hug its content. */\n.fund-single-select-dropdown.scrollable {\n  max-height: 448px;\n  overflow-y: auto;\n}\n\n.fund-single-select-options {\n  display: flex;\n  flex-direction: column;\n}\n\n.fund-single-select-option-item {\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  height: 48px;\n  padding: 12px 16px;\n  cursor: pointer;\n  color: var(--text-primary);\n  text-align: left;\n}\n\n.fund-single-select-option-item:hover {\n  background-color: var(--color-brand-hover2);\n}\n\n.fund-single-select-option-item.active {\n  background-color: var(--color-brand-hover2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
